import { __decorate, __metadata } from "tslib";
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import _ from 'lodash';
import { E_PATENT_FIELD } from '../enums/patent';
let DatasetPatentApiDtoImpl = class DatasetPatentApiDtoImpl {
    constructor() {
    }
    formatData(data) {
        return {
            ..._.omit(data, ['patents_data']),
            records: data.patents_data.map((patent) => {
                const standard = {};
                const custom_fields = {};
                _.mapKeys(patent, (value, key) => {
                    if (_.includes(E_PATENT_FIELD, key)) {
                        standard[key] = value;
                    }
                    else {
                        custom_fields[key] = value;
                    }
                });
                const comments = patent.COMMENTS;
                return {
                    ID: patent.PATENT_ID,
                    standard,
                    custom_fields,
                    comments,
                    read_status: patent.read_status,
                };
            }),
        };
    }
};
DatasetPatentApiDtoImpl = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], DatasetPatentApiDtoImpl);
export { DatasetPatentApiDtoImpl };
